/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Trust_Uptime_SlaInputs */



/**
* | output |
* | --- |
* | "99.9% uptime SLA" |
*
* @param {Pricing_Trust_Uptime_SlaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_trust_uptime_sla = /** @type {((inputs?: Pricing_Trust_Uptime_SlaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Trust_Uptime_SlaInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("99,9% Verfügbarkeits-SLA")
	return /** @type {LocalizedString} */ ("99.9% uptime SLA")
});